export function addCoins(coins) {
  return {
    type: 'ADD_COINS',
    payload: coins,
  };
}

export function removeCoins(coins) {
  return {
    type: 'REMOVE_COINS',
    payload: coins,
  };
}

export function updateWeight(weight) {
  return {
    type: 'UPDATE_WEIGHT',
    payload: weight,
  };
}
